import {
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
  type DocumentReference,
  doc,
  getFirestore,
} from 'firebase/firestore';
import type {CourseId, UserId} from 'types/common';

export type SelfCheckProgressId = string;

export interface SelfCheckProgress {
  [selfCheckProgressId: SelfCheckProgressId]: boolean;
}

const isSelfCheckProgress = (data: unknown): data is SelfCheckProgress => {
  return (
    typeof data === 'object' &&
    data !== null &&
    Object.values(data).every(Boolean)
  );
};

export const getSelfCheckProgressFirebasePath = ({
  userId,
  courseId,
}: {
  userId: UserId;
  courseId: CourseId;
}) => {
  return `users/${userId}/${courseId}/selfCheckProgress`;
};

export const SELF_CHECK_PROGRESS_DOC_CONVERTER: FirestoreDataConverter<SelfCheckProgress> =
  {
    toFirestore: (selfCheckProgress: SelfCheckProgress) => selfCheckProgress,
    fromFirestore: (snapshot: QueryDocumentSnapshot) => {
      const data = snapshot.data();
      if (!isSelfCheckProgress(data)) {
        console.error(
          'Invalid self check progress data. Silently failing.',
          data,
        );
        return {};
      }
      return data;
    },
  };

export const getSelfCheckProgressDocumentReference = ({
  userId,
  courseId,
}: {
  userId: UserId;
  courseId: CourseId;
}): DocumentReference<SelfCheckProgress> => {
  return doc(
    getFirestore(),
    getSelfCheckProgressFirebasePath({userId, courseId}),
  ).withConverter(SELF_CHECK_PROGRESS_DOC_CONVERTER);
};
